import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
  useRouter,
} from 'expo-router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import { HomeTileTypeIds } from 'shared/hooks/homeTiles/HomeTileTypeIds';
import useRefreshHomeTiles from 'shared/hooks/homeTiles/useRefreshHomeTiles';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import useDismissToRootTab, {
  Tabs,
} from 'shared/hooks/useDismissToRootTab/useDismissToRootTab';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';
import theme from 'shared/styles/theme';

const HardPullApprovedScreen = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('vloc', {
    keyPrefix: 'approved',
  });
  const {
    approvedTitle,
    approvedCongratsText,
    approvedDescription,
    approvedAdditionalQualifications,
    tierId,
  } = useLocalSearchParams<{
    approvedTitle?: string;
    approvedCongratsText?: string;
    approvedDescription?: string;
    approvedAdditionalQualifications?: string;
    tierId: string;
  }>();

  const dismissToTab = useDismissToRootTab();

  const goHome = () => {
    dismissToTab(Tabs.HOME);
  };

  useBackHandler(goHome);

  const { refreshTiles } = useRefreshHomeTiles([
    HomeTileTypeIds.VLOC_ACCOUNT_CARD_SQUARE_TILE,
    HomeTileTypeIds.VXL_SIDE_BY_SIDE_TILE_ACCOUNT_CARD,
    HomeTileTypeIds.VXL_TRACKER_CARD_TILE_CREDIT_TRACKER,
  ]);

  useEffect(() => {
    refreshTiles();
  }, [refreshTiles]);

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
          headerShown: false,
          gestureEnabled: false,
        }}
      />
      <SuccessScreen
        visual="HIGH_FIVE_A"
        titleText={approvedTitle ?? ''}
        eyebrowText={approvedCongratsText ?? ''}
        content={
          <View>
            <BodyBaseText style={styles.bodyText} numberOfLines={0}>
              {approvedDescription ?? ''}
            </BodyBaseText>
            <BodyXSText style={styles.noteText} numberOfLines={0}>
              {approvedAdditionalQualifications ?? ''}
            </BodyXSText>
          </View>
        }
        primaryButton={{
          label: translatedText('buttons.borrowNow'),
          onPress: () => {
            router.navigate({
              pathname: '/varo-line-of-credit/review',
              params: {
                tierId: tierId,
                subcategory: 'vloc_application',
              },
            });
          },
          analyticsId: 'borrowNow',
        }}
        secondaryButton={{
          label: translatedText('buttons.borrowLater'),
          onPress: goHome,
          analyticsId: 'borrowLater',
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  bodyText: {
    color: theme.color.text.primary,
    textAlign: 'center',
  },
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  noteText: {
    color: theme.color.text.secondary,
    paddingVertical: theme.spacing.m,
    textAlign: 'center',
  },
});

export default HardPullApprovedScreen;
